import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as reportingAPI from 'api/Settings/settingreporting';
import { openSnackbar } from 'store/reducers/snackbar';

const initalState = {
  data: null,
  teams: null,
  teamId: null,
  selectedTeam: null,
  updateData: null,
  ui: {
    loading: false,
    msg: ''
  },
  status: 'init'
};

const getReportingData = createAsyncThunk('settingReporting/getReportingData', async (id, { rejectWithValue }) => {
  try {
    const res = await reportingAPI.getReportingData({ id });
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const getAllTeams = createAsyncThunk('settingReporting/getAllTeams', async (_, { rejectWithValue }) => {
  try {
    const res = await reportingAPI.getAllTeams();
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const updateReportingData = createAsyncThunk(
  'settingReporting/updateReportingData',
  async ({ signal, ...params }, { dispatch, rejectWithValue }) => {
    try {
      const res = await reportingAPI.updateReportingData(params, signal);
      return res.data?.data;
    } catch (error) {
      dispatch(
        openSnackbar({
          open: true,
          message: error.response.data?.message,
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: false
        })
      );
      return rejectWithValue(error);
    }
  }
);

const settingReportingSlice = createSlice({
  name: 'settingReporting',
  initialState: initalState,

  reducers: {
    resetState: () => {
      return initalState;
    },
    setSelectedTeam: (state, action) => {
      if (action.payload) state.selectedTeam = action.payload;
    },
    setTeamId: (state, action) => {
      state.teamId = action.payload;
    }
  },
  extraReducers: {
    [getAllTeams.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getAllTeams.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.teams = action.payload;
      if (!state.selectedTeam) state.selectedTeam = action.payload?.[0]?.name || null;
    },

    [getAllTeams.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getReportingData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getReportingData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.data = action.payload;
    },

    [getReportingData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [updateReportingData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [updateReportingData.fulfilled]: (state, action) => {
      console.log('action', action.payload);
      state.status = 'idle';
      state.ui.loading = false;
      // const updatedItem = action.payload;
      // const updatedItems = state.data.map((item) => {
      //   if (item.id === updatedItem.id) {
      //     return updatedItem;
      //   }
      //   return item;
      // });
      // state.data = updatedItems;
    },

    [updateReportingData.rejected]: (state, action) => {
      console.log('dsadasdas', action.payload);
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

const { resetState, setSelectedTeam, setTeamId } = settingReportingSlice.actions;

export default settingReportingSlice.reducer;

export { getReportingData, updateReportingData, resetState, getAllTeams, setSelectedTeam, setTeamId };
